/* eslint-disable @reatom/unit-naming-rule */
import { CurrencyModel } from '@root/entities/currency/model'
import { reatomPremiumMeta } from '@root/entities/premium/atoms/reatom-premium-meta'

import { reatomPair } from './reatom-pair'

import type { PairReusedShort } from '../model/pair'
import type { ServicesPoolReusedImageListData } from '@blade/trade-api-client'
import type { TokenLogosHost } from '@root/shared/models'

export const fromReusedImageDto = (
  reusedImage: ServicesPoolReusedImageListData[number],
  imagesHost: TokenLogosHost,
): PairReusedShort => {
  const quote = CurrencyModel.fromTokenMeta(reusedImage.quote, imagesHost)

  const pair = reatomPair(
    {
      ...reusedImage,
      allTimeHigh: {
        ...reusedImage.allTimeHigh,
        marketCap: reusedImage.athMarketCap,
      },
    },
    imagesHost,
    reatomPremiumMeta({
      dto: reusedImage.premiumInfo,
      currency: quote,
    }),
  )

  return { ...pair, traders24h: reusedImage.traders24h }
}
